import root from 'window-or-global'
import { Trinity, GoogleTagManager, AdobeTracking } from 'pkg-trinity-client'
import { client } from 'carol'
import { handleError } from './handleError'
import { getSourceIP } from './getSourceIP'
import { mutationToHandler } from './tracking/tracking_handler.ts'

const INTERNAL_IP_ADDRESS = '91.223.2.4'

async function handleInternalTraffic() {
  const addresses = await getSourceIP()
  if (
    addresses !== undefined &&
    (addresses.client_ip === INTERNAL_IP_ADDRESS ||
      addresses.sourceIP === INTERNAL_IP_ADDRESS)
  ) {
    gtmDataLayerPusher({ trafficType: 'internal traffic' })
    adobeDataLayerPusher({ trafficType: 'internal traffic' })
  } else {
    gtmDataLayerPusher({ trafficType: 'external traffic' })
    adobeDataLayerPusher({ trafficType: 'external traffic' })
  }
}

const gtmDataLayerPusher = event => {
  root.dataLayer2018.push(event)
}

const adobeDataLayerPusher = event => {
  root.adobeDataLayer.push(event)
}

const consoleSender = event => {
  console.log(event)
}

root.trinity = {
  buffer: [],
  onStateChange: function (mutation, state) {
    this.buffer.push({ mutation, state })
  },
}

function compileRegex(mapping) {
  // Convert string to RegExp
  for (const category of mapping) {
    for (const page of category.pages) {
      page.regex = new RegExp(page.regex)
    }
  }
  return mapping
}

function newTrinity(mapping) {
  const settings =
    mapping === undefined
      ? undefined
      : { mapping: compileRegex(mapping), storage: root.localStorage }
  const buffer = root.trinity.buffer

  if (root.isClient) {
    if (process.env.STAGE === 'prod') {
      root.trinity = new Trinity(
        new GoogleTagManager(event => {
          gtmDataLayerPusher(event)
        }, settings),
      )
    } else {
      root.trinity = new Trinity(
        new GoogleTagManager(event => {
          gtmDataLayerPusher(event)
        }, settings),
      )
    }
    root.trinity = new Trinity(new AdobeTracking(mutationToHandler))
    root.trinity.errorLogger = handleError
  } else {
    const subscriber = new GoogleTagManager(consoleSender, settings)
    root.trinity = new Trinity(
      {
        onStateChange: (mutation, state) => {
          subscriber.onStateChange(mutation, state)
        },
      },
    )
    root.trinity = new Trinity(new AdobeTracking(mutationToHandler, true))
  }
  try {
    if (isIterable(buffer)) {
      for (const { mutation, state } of buffer) {
        root.trinity.onStateChange(mutation, state)
      }
    }
  } catch (e) {
    console.error('trinity: could not iterate over buffer', e)
  }
}

function isIterable(obj) {
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === 'function';
}

export function init(store) {
  if (root.isClient) {
    handleInternalTraffic().catch(err =>
      console.error('internal traffic detection', err)
    )
  }
  store.subscribe((mutation, state) => {
    try {
      root.trinity.onStateChange(mutation, state)
    } catch (err) {
      console.error(err)
    }
  })
  client
    .trackingPageCategories({
      keys: ['category', 'pages'],
    })
    .then(newTrinity)
    .catch(_ => newTrinity())
}
